import React from "react";
import PredictionPage from "../../components/PredictionPage";

function BitcoinCash() {
  return (
    <PredictionPage
      title="Bitcoin Cash"
      content="This is the Bitcoin Cash AI Trading Predictions page."
      canonical="/cryptocurrencies/bitcoin-cash-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="BITCOINCASH"
    />
  );
}

export default BitcoinCash;
